// components/features/faq/FaqsList.tsx
import { Faq } from "../../../types/features/Faq";
import TableList, { SelectAction } from "../../ui/TableList";
import FaqRow from "./FaqRow";

interface FaqsListProps {
  faqs: Faq[];
  onAction: (faq: Faq) => void;
  onSelectFaqs?: (selectedFaqs: Faq[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
  dragHandleProps?: any;
}

export default function FaqsList({
  faqs,
  onAction,
  onSelectFaqs,
  selectable = false,
  selectActions,
  dragHandleProps,
}: FaqsListProps) {
  const columns = [
    { header: "Question", className: "w-2/5" },
    { header: "Réponse", className: "w-2/5" },
    { header: "Statut", className: "hidden lg:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={faqs}
      columns={columns}
      getId={(faq) => faq.id}
      onAction={onAction}
      onSelectItems={onSelectFaqs}
      selectable={selectable}
      emptyMessage="Aucune FAQ trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(faq, isSelected, onSelect) => (
        <FaqRow
          key={faq.id}
          faq={faq}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
          dragHandleProps={dragHandleProps}
        />
      )}
    />
  );
}
